import { render, staticRenderFns } from "./configField.vue?vue&type=template&id=128a95af&scoped=true&"
import script from "./configField.vue?vue&type=script&lang=js&"
export * from "./configField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a95af",
  null
  
)

export default component.exports